module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/companies/company-logo-19-103878a5d70c902b91a0da5b6ce0acec.png";